import {makeStyles} from '@material-ui/core';
import Grid from '@material-ui/core/Grid';
import Typography from '@material-ui/core/Typography';
import LocalizedText from 'commons/LocalizedText/LocalizedText';
import React from 'react';

const useStyles = makeStyles(() => ({
  generalContainer: {
    height: '70px'
  },
  redValue: {
    color: 'red'
  },
  greenValue: {
    color: 'green',
    fontWeight: 'bold'
  },
  blackValue: {
    color: 'black'
  }
}));

export const SimpleText = ({ label, value, color}) => {
  const classes = useStyles();

  let colorText = '';
  switch (color) {
  case 'black':
    colorText = classes.blackValue;
    break;
  case 'green':
    colorText = classes.greenValue;
    break;
  case 'red':
    colorText = classes.redValue;
    break;
  default:
  }

  return (
    <Grid item>
      <Grid alignItems='center' className={classes.generalContainer} container justifyContent='space-between' spacing={2} wrap="nowrap">
        <Grid item xs={6}>
          <LocalizedText  align='right' isTextLabel >
            {label}
          </LocalizedText>
        </Grid>
        <Grid item xs={6}>
          <Typography
            className={colorText}
            style={{ wordWrap: "break-word"}}>
            {value || '-'}
          </Typography>
        </Grid>
      </Grid>
    </Grid>
  );
};